import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { getVideo } from '@/api/center'
import playImg from '@/assets/images/play.png'
import tvImg from '@/assets/images/tv.png'
import wxcloseImg from '@/assets/images/wxclose.png'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import Loadding from '@/components/Loadding'
import Modal from '@/components/Modal'
import { deviceInfoStore, globalStore, themeStore, useRecoilState, useRecoilValue, useSetRecoilState } from '@/store'

const { addProWxWinState, proWxWinEqState } = globalStore

export default function Index() {
  const [addProWxWin, setAddProWxWin] = useRecoilState(addProWxWinState)
  const [proWxWinEq, setProWxWinEq] = useRecoilState(proWxWinEqState)
  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="relative">
      <Modal
        show={addProWxWin}
        shadowClick={false}
        title={''}
        cancel={() => {
          setAddProWxWin(false)
          setProWxWinEq('')
        }}
        footer=""
        header=""
        className="video-modal"
      >
        <div className="tv"></div>
        <div className="close anim_btn2" onClick={() => setAddProWxWin(false)}></div>
        <div className="content">
          <div className="end">
            <div className="box"></div>
          </div>
          <div className="t1">欢迎回来</div>
          <div className="t2">赠送给您一节直播课</div>
          <div className="txt">60分钟1对1体验 | 1次美术能力测评 | 1次学习提升规划</div>
          <div className="eqcode">
            <img className="w-full h-full" src={proWxWinEq} alt="" />
          </div>
          <div className="addteac">立即扫码添加老师微信 安排上课</div>
          <div className="ignore">*如已添加请忽略</div>
        </div>
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  background-color: #fff;
  border-radius: 6px;
  .video-modal {
    width: 750px;
    height: 710px;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0;
    transform: scale(0.75);
    .tv {
      background: url(${tvImg}) no-repeat center;
      background-size: 100% auto;
      width: 200px;
      height: 200px;
      margin-top: -100px;
      position: fixed;
      z-index: 9;
    }
    .close {
      cursor: pointer;
      background: url(${wxcloseImg}) no-repeat center;
      background-size: 100% auto;
      width: 200px;
      height: 200px;
      width: 54px;
      height: 54px;
      position: fixed;
      margin-left: 700px;
      margin-top: -100px;
    }
    .content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .end {
        flex: 1;
        display: flex;
        align-items: flex-end;
        .box {
          width: 147px;
          height: 24px;
          background: linear-gradient(90deg, #fff 0%, #ffb8b8 53%, #fff 100%);
          opacity: 0.73;
          filter: blur(5);
        }
      }
      .t1 {
        color: #2f2f2f;
        font-size: 48px;
        margin: 5px auto;
      }
      .t2 {
        color: #000000;
        font-size: 40px;
        margin: 5px auto;
      }
      .txt {
        color: #666666;
        font-size: 24;
      }
      .eqcode {
        width: 240px;
        height: 240px;
        margin: 20px auto;
        border: 1px solid #e1e1e1;
        background-color: #e1e1e1;
      }
      .addteac {
        color: #fc5323;
        font-size: 34px;
      }
      .ignore {
        width: 100%;
        height: 100px;
        color: #666666;
        font-size: 24px;
        text-align: center;
        background: linear-gradient(180deg, #ffffff 0%, #ffffff 0%, #ffbbbb 100%);
        border-radius: 12px;
        padding-top: 10px;
      }
    }
  }
`
